import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
    name: "templates",
    initialState: {
        list: [],
        loading: true,
        saveLoading: false,
        lastFetch: null,
        addedStatus:false,
        updatedStatus:false,
        sendStatus:false,
        templateForm:null,
        templatePdf:null,
        emailTemplates: [],
        letterTemplates: []
    },
    reducers: {
        templateRequestStarted: (templates) => {
            templates.loading = true;
            templates.addedStatus = false;
            templates.updatedStatus = false;
            templates.sendStatus = false;
        },
        templateRequestFailed: (templates) => {
            templates.loading = false;
        },
        templateSaveStarted: (templates) => {
            templates.saveLoading = true;
            templates.addedStatus = false;
            templates.updatedStatus = false;
            templates.sendStatus = false;
        },
        templateSaveFailed: (templates) => {
            templates.saveLoading = false;
        },
        appTemplatesReceived:(templates,action)=>{
            templates.list=action.payload;
            templates.addedStatus=false;
            templates.updatedStatus=false;
            templates.sendStatus=false;
            templates.loading=false;
        },
        appTemplateAdded:(templates,action)=>{
            templates.addedStatus=true;
            templates.loading=false;
            templates.saveLoading=false;
        },
        appTemplateUpdated:(templates,action)=>{
            templates.updatedStatus=true;
            templates.loading=false;
            templates.saveLoading=false;
        },
        appTemplateSent:(templates,action)=>{
            templates.sendStatus=true;
            templates.loading=false;
        },
        templateFormReceived:(templates,action)=>{
            templates.templateForm=action.payload;
            templates.loading=false;
        },
        templatePdfReceived:(templates,action)=>{
            templates.templatePdf=action.payload;
            templates.loading=false;
        },
        formsByTypeReceived:(templates,action)=>{
            if(action.payload.type === "EmailTemplate")
                templates.emailTemplates = action.payload.data;
            else if(action.payload.type === "LetterTemplate")
                templates.letterTemplates = action.payload.data;
            
            templates.loading=false;
        }
        
    }
});

export const { templateRequestStarted, templateRequestFailed, appTemplatesReceived,appTemplateAdded,
    appTemplateUpdated, templatePdfReceived, templateFormReceived,appTemplateSent, formsByTypeReceived,
    templateSaveStarted, templateSaveFailed } = slice.actions;
export default slice.reducer;

export const loadAppTemplates = (id) => apiCallBegan({
    url: config.GetSentTemplates + id,
    onStart: { type: templateRequestStarted.type },
    onError: { type: templateRequestFailed.type },
    onSuccess: appTemplatesReceived.type
});

export const loadFormsByType = (type) => apiCallBegan({
    url: config.GetFormsByType + type,
    onStart: { type: templateRequestStarted.type },
    onError: { type: templateRequestFailed.type },
    onSuccess: { type: formsByTypeReceived.type, payload: { type } }
});

export const loadTemplateForm = (id) => apiCallBegan({
    url: config.GetForm + id,
    onStart: { type: templateRequestStarted.type },
    onError: { type: templateRequestFailed.type },
    onSuccess: templateFormReceived.type
});

export const sentAppTemplate = (id) => apiCallBegan({
    url: config.SentTemplate + id,
    onStart: { type: templateRequestStarted.type },
    onError: { type: templateRequestFailed.type },
    onSuccess: appTemplateSent.type
});

export const addAppTemplate = (data) => apiCallBegan({
    url: config.AddTemplate,
    method:"post",
    data:data,
    onStart: { type: templateSaveStarted.type },
    onError: { type: templateSaveFailed.type },
    onSuccess: appTemplateAdded.type
});

export const updateAppTemplate = (data) => apiCallBegan({
    url: config.UpdateTemplate,
    method:"post",
    data:data,
    onStart: { type: templateSaveStarted.type },
    onError: { type: templateSaveFailed.type },
    onSuccess: appTemplateUpdated.type
});

export const printTemplatePdf = (data) => apiCallBegan({
    url: config.PrintTemplate,
    method: "post",
    data: data,
    responseType: "blob",
    onStart: { type: templateRequestStarted.type },
    onError: { type: templateRequestFailed.type },
    onSuccess: templatePdfReceived.type
});

export const getAppTemplates = createSelector(
    state => state.entities.templates,
    templates => templates.list
);

export const getTemplateLoading = createSelector(
    state => state.entities.templates,
    templates => templates.loading
);

export const getTemplateSaveLoading = createSelector(
    state => state.entities.templates,
    templates => templates.saveLoading
);

export const getTemplateForm = createSelector(
    state => state.entities.templates,
    templates => templates.templateForm
);

export const getAppTemplateAddedStatus = createSelector(
    state => state.entities.templates,
    templates => templates.addedStatus
);

export const getAppTemplateUpdatedStatus = createSelector(
    state => state.entities.templates,
    templates => templates.updatedStatus
);
export const getAppTemplateSentStatus = createSelector(
    state => state.entities.templates,
    templates => templates.sendStatus
);
export const getTemplatePdf = createSelector(
    state => state.entities.templates,
    templates => templates.templatePdf
);

export const getEmailTemplates = createSelector(
    state => state.entities.templates,
    templates => templates.emailTemplates
);

export const getLetterTemplates = createSelector(
    state => state.entities.templates,
    templates => templates.letterTemplates
);

